<template>
  <div class="page">
    <div class="goods-title">请输入具体商品信息</div>
    <!-- 商品信息 -->
    <div class="goods-info">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" inline>
        <el-form-item label="商品名称" prop="name" required>
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="商品类型" prop="category" required>
          <el-select v-model="ruleForm.category" placeholder="请选择商品类型" :disabled="detailFlag === 'edit'" style="width:92%">
            <el-option label="伴学精灵" :value="0" v-if="detailFlag === 'edit'"></el-option>
            <el-option label="头像挂件" :value="1" v-if="detailFlag === 'edit'"></el-option>
            <el-option label="实物" :value="2"></el-option>
            <el-option label="头像" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <!-- 创建的时候没有，自动生成，编辑的时候能看到并且disabled -->
        <el-form-item label="商品编号" prop="productNumber" class="is-required" v-if="detailFlag === 'edit'">
          <el-input v-model="ruleForm.productNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="兑换星币数" prop="starNum" required>
          <el-input v-model.number="ruleForm.starNum" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="商品库存" prop="inventory" required>
          <el-input v-model.number="ruleForm.inventory" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="商品成本" prop="cost" required>
          <el-input v-model="ruleForm.cost" @input="requiredCost" style="width: 204px;">
            <template slot="prefix">
              ￥
            </template>
          </el-input>
          <!-- <el-input-number
            v-model="ruleForm.cost"
            :precision="2"
            :step="0.01"
            :min="0"
            :max="Infinity"
            label="请输入商品成本"
          >
        </el-input-number> -->
        </el-form-item>

        <el-form-item label="分校选择" prop="eduCampusIdList" required>
          <el-cascader :disabled="detailFlag === 'edit'" v-model="ruleForm.eduCampusIdList" :options="multipleCampusData" :props="{ multiple: true }" clearable @change="methodChangeCampus" style="width:92%"></el-cascader>
        </el-form-item>
        <el-form-item label="排序号" prop="sort" required :label-width="detailFlag === 'edit' ? '85px' : '100px'">
          <el-input-number v-model="ruleForm.sort" :precision="1" :step="0.1" controls-position="right" :min="0" :max="Infinity" label="请输入排序号"></el-input-number>
        </el-form-item>
        <br />
        <el-form-item label="商品图片" required prop="highPictureUrl">
          <el-upload :disabled="detailFlag === 'edit' && ruleForm.category !== 2" action="" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :on-exceed="handleExceed" :file-list="fileList" list-type="picture-card" accept="" style="width: 400px" :class="{ hide: detailFlag === 'edit' && ruleForm.category !== 2 }">
            <i class="el-icon-plus"></i>
            <!-- <el-button size="mini" type="primary" plain>点击上传</el-button> -->
            <div slot="tip" class="el-upload__tip" style="color:#e4393c">
              * 只能上传jpg/png文件，且不超过2mb{{
                ruleForm.category === 3 ? '（建议尺寸200*200）' : ''
              }}
            </div>
          </el-upload>
        </el-form-item>
        <br />
        <el-form-item style="margin-top:100px;">
          <el-button @click="cancelForm()" size="small">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作按钮 -->
    <!-- <div class="operation">
      <el-button size="small">取消</el-button>
      <el-button type="primary" size="small">保存</el-button>
    </div> -->
  </div>
</template>
<script>
import { api_schoolProductCreate, api_schoolProductEdit } from '@/api/javaApi'
import { getUserCampusList } from '@/api/educational'
import uploadFile from '@/config/uploadFile'

export default {
  name: 'goodsDetail',
  data: () => ({
    detailFlag: 'add',
    uploadFileTime: false,
    fileList: [],
    ruleForm: {
      category: null, // 商品类型 0为伴学精灵，1为头衔，2为实物
      productNumber: '', // 商品编号：创建时没有，自动生成，编辑的时候显示并且禁用
      name: '', // 商品名称
      highPictureUrl: '', // 图片地址
      starNum: '', // 兑换星币数
      inventory: '', // 库存
      cost: '', // 成本
      creator: '', // 创建者
      updater: '', // 更新者
      eduCampusIdList: [], // 所属分校
      sort: '',
    },
    campusMap: {},
    rules: {
      name: [
        {
          required: true,
          message: '请输入商品名称',
          trigger: ['blur', 'change'],
        },
        {
          min: 1,
          max: 15,
          message: '长度在 1 到 15 个字符',
          trigger: ['blur', 'change'],
        },
      ],
      category: [
        { required: true, message: '请选择商品类型', trigger: 'blur' },
      ],
      starNum: [
        {
          required: true,
          message: '请输入兑换星币数量',
          trigger: ['blur', 'change'],
        },
      ],
      inventory: [
        {
          required: true,
          message: '请输入库存数量',
          trigger: ['blur', 'change'],
        },
      ],
      cost: [
        {
          required: true,
          message: '请输入商品成本',
          trigger: ['blur', 'change'],
        },
      ],
      eduCampusIdList: [
        {
          required: true,
          type: 'array',
          message: '请选择分校',
          trigger: 'change',
        },
      ],
      highPictureUrl: [
        { required: true, message: '请上传图片', trigger: 'change' },
      ],
      sort: [
        {
          required: true,
          message: '请输入排序号',
          trigger: ['blur', 'change'],
        },
      ],
    },
    campusData: [],
  }),
  computed: {
    // 多选校区数据改造
    multipleCampusData() {
      const campusList = this.campusData
      campusList.forEach((item) => {
        item.label = item.campusName
        item.value = item.id
      })
      return campusList
    },
  },
  created() {
    this.getUserCampusList()
    // 编辑走此
    const routeParams = this.$route.query
    this.detailFlag = Object.keys(routeParams).join('') !== '' ? 'edit' : 'add'
    if (this.detailFlag === 'edit') {
      this.ruleForm = {
        category: Number(routeParams.category), // 商品类型 0为伴学精灵，1为头衔，2为实物
        productNumber: routeParams.productNumber, // 商品编号：创建时没有，自动生成，编辑的时候显示并且禁用
        name: routeParams.name, // 商品名称
        highPictureUrl: routeParams.highPictureUrl, // 图片地址
        starNum: routeParams.starNum, // 兑换星币数
        inventory: routeParams.inventory, // 库存
        cost: routeParams.cost, // 成本
        updater: this.$store.state.user.userInfo.id, // 更新者
        eduCampusIdList: [routeParams.eduCampusId], // 所属分校
        sort: Number(routeParams.sort),
      }

      this.fileList = [
        {
          url:
            // this.$store.state.resource.picBaseUrl +
            (this.ruleForm.highPictureUrl = routeParams.highPictureUrl),
        },
      ]
    }
  },
  methods: {
    async getUserCampusList() {
      await getUserCampusList().then((res) => {
        res.userDeptList.forEach((item) => {
          item.id = item.dept_id
        })
        this.campusData = res.userDeptList

        for (const campusItem of this.campusData) {
          this.campusMap[campusItem.id] = campusItem.campusName
        }
      })
    },
    submitForm(formName) {
      this.ruleForm.creator = this.$store.state.user.userInfo.id
      this.ruleForm.updater = this.$store.state.user.userInfo.id
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          if (this.detailFlag === 'add') {
            this.schoolProductCreate()
          } else {
            this.schoolProductEdit()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelForm() {
      this.$router.back()
    },
    // 新增
    async schoolProductCreate() {
      await api_schoolProductCreate({
        ...this.ruleForm,
        // category: 0, // 商品类型（0为头像，1为头衔）
        // name: '小贾头像测试', // 商品名称
        // highPictureUrl: 'aaabbb', // 图片地址
        // starNum: 1, // 兑换星币数
        // inventory: 20, // 库存
        // creator: '贾禄鑫', // 创建者
        // updater: '贾禄鑫', // 更新者
      }).then((res) => {
        if (res === '商品名称重复不能提交') {
          this.$message.error(res)
        } else {
          // this.$router.replace({
          //   name: 'goodsManagement',
          //   query: { refresh: true },
          // })
          this.$router.back()
        }
      })
    },
    // 编辑
    async schoolProductEdit() {
      const routeParams = this.$route.query
      const params = {
        id: routeParams.id,
        // cost: this.ruleForm.cost, // 商品名称
        // highPictureUrl: this.ruleForm.highPictureUrl, // 图片地址
        // starNum: this.ruleForm.starNum, // 兑换星币数
        // inventory: this.ruleForm.inventory, // 库存
        updater: this.$store.state.user.userInfo.id, // 更新者
        eduCampusId: routeParams.eduCampusId,
      }
      if (this.ruleForm.name !== routeParams.name) {
        params.name = this.ruleForm.name
      }
      if (this.ruleForm.cost !== routeParams.cost) {
        params.cost = this.ruleForm.cost
      }
      if (this.ruleForm.highPictureUrl !== routeParams.highPictureUrl) {
        params.highPictureUrl = this.ruleForm.highPictureUrl
      }
      if (this.ruleForm.starNum !== routeParams.starNum) {
        params.starNum = this.ruleForm.starNum
      }
      if (this.ruleForm.inventory !== routeParams.inventory) {
        params.inventory = this.ruleForm.inventory
      }
      if (this.ruleForm.sort !== Number(routeParams.sort)) {
        params.sort = this.ruleForm.sort
      }
      console.log('routeParams:', routeParams)
      console.log('params:', params)
      await api_schoolProductEdit(params).then(() => {
        // this.$refs['ruleForm'].resetFields()
        // this.$router.replace({
        //   name: 'goodsManagement',
        //   query: { refresh: true },
        // })
        this.$router.back()
      })
    },
    updateImages(row) {
      this.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    handleExceed() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },
    async handleChangeFile(file, fileList) {
      console.log(file, fileList)
      const nameIndex = file.name.lastIndexOf('.')
      const isAllowedType = ['.jpeg', '.png', '.jpg'].includes(
        file.name.substring(nameIndex)
      )
      // const isAllowedSize = file.size / 1024 < 500 // 小于500kb
      const isAllowedSize = file.size / 1024 / 1024 < 2 // 小于2M

      if (!isAllowedType) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        this.fileList.pop()
      } else if (!isAllowedSize) {
        this.$message.error('上传的图片大小不能超过 2mb!')
        this.fileList.pop()
      }
      if (isAllowedType && isAllowedSize && !this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code, true).then(
        (res) => {
          console.log(res)
          this.fileList = res
          if (res && res.length > 0) {
            this.ruleForm.highPictureUrl = res[0].name
          }
          this.uploadFileTime = false
        }
      )
    },
    methodChangeCampus(arr) {
      this.ruleForm.eduCampusIdList = arr.flat(Infinity)
    },
    requiredCost(value) {
      // eslint-disable-next-line
      let dat =
        ('' + value) // 第一步：转成字符串
          .replace(/[^\d^.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      // 限制输入最大值为100
      // if (Number(dat) >= 100) {
      //         return;
      // }
      this.ruleForm.cost = dat
    },
  },
}
</script>
<style scoped lang="scss">
.page {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px #f0f4f5;
  border-radius: 5px;
  border: 1px solid #f4f5f9;

  .goods-title {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 16px;
    color: #999;
    line-height: 22px;
    letter-spacing: 1px;
  }
  .goods-info {
    .el-form {
      max-width: 800px;
      ::v-deep.hide .el-upload--picture-card {
        display: none;
      }
    }
  }

  .operation {
    position: fixed;
    bottom: 40px;
  }
}
</style>
